import React from "react";
import Text from "shared/ui/typography/Text";
import Heading from "../../../../shared/ui/typography/Heading";
import { acousticPanelMontageServiceUsps } from "../../../../shared/utils/usps";
import Icon, { IconTypes } from "../../../../shared/ui/icon";
import ColoredCheckmark from "../../../../shared/ui/colored-checkmark";

interface Props {}

export const MontageServiceSection = ({}: Props) => {
  return (
    <div
      className={
        "gg-border-b gg-border-dark-blue-100 gg-px-4 gg-py-2 sm:gg-px-7"
      }
    >
      <div className={"gg-py-4"}>
        <div
          className={
            "gg-flex gg-flex-row gg-items-end gg-justify-between gg-px-4"
          }
        >
          <div className={"gg-h-24 gg-w-24 gg-rounded gg-bg-dark-blue"}>
            <Icon name={IconTypes.MONTAGE_MAN} className={"gg-p-4"} />
          </div>
          <Text className="gg-align-right gg-shrink-0 gg-text-dark-blue-700">
            Vanaf €389,-
          </Text>
        </div>
        <div className={"-gg-mt-10 gg-rounded gg-bg-gray-100 gg-p-4 gg-pt-12"}>
          <Heading headingLevel="h4" className="gg-flex">
            Jij kiest, wij monteren
          </Heading>
          <Text className="gg-col-span-9 gg-mb-4 gg-mt-1 gg-pr-6 gg-text-sm 2xl:gg-mb-6">
            Liever niet zelf monteren? Maak dan gebruik van de GewoonGers
            montageservice. Dit kun je toevoegen aan je bestelling in stap 3.
            Voor het monteren van de eerste 3 panelen betaal je €389,- incl. BTW
            en voor ieder extra paneel rekenen wij een bedrag van €52,50. Moeten
            er sparingen in het paneel komen, bijvoorbeeld voor stopcontacten?
            Dan rekenen wij hiervoor €25,- per stuk.
          </Text>

          <div>
            <ul className="gg-grid gg-gap-y-[0.4rem]">
              {Object.values(acousticPanelMontageServiceUsps).map(
                (usp, index) => (
                  <li
                    key={index}
                    className="gg-flex gg-gap-x-[0.35rem] lg:gg-items-center"
                  >
                    <ColoredCheckmark fill={"#292747"} />
                    <Text className="gg-w-full gg-text-sm gg-leading-6 gg-text-slate-800">
                      {usp}
                    </Text>
                  </li>
                ),
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
